import React from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { appAuth } from "../../../components/appAuth";
import { receptionistTabMenu } from '../../../global-props'
import LanguageSelector from '../../../components/language-selector';
import { openGarageGate } from "./../../../models/setting";
import Button from './../../../components/button';

class ReceptionistTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'Dashboard',
      showAdmin: false,
      modal: false,
    };
    this.modalToggle = this.modalToggle.bind(this);
  }

  componentDidMount() {
    let page = this.props.page;
    this.setState({view: page});
    appAuth.checkAuthorization();
    if((appAuth.authorization&&appAuth.authorization.roles.includes('Admin'))||(appAuth.authorization&&appAuth.authorization.username==="Reception")){
      this.setState({showAdmin: true})
    }
  }

  modalToggle(){
    this.setState({modal: !this.state.modal})
  }

  handleOpen(){
    this.setState({
      isSubmitting: true
    })
    openGarageGate()
    .then(result=>{
      this.setState({isSubmitting:false, modal: false,});
    }, error => {this.setState({error: error,isSubmitting:false})})
  }

  render() {
    const { t, siteSettings, isPrinterErrors } = this.props;
    const { view, showAdmin, isSubmitting } = this.state;
    return (
      <>
      <Nav className="reception-tabs font-weight-normal justify-content-between">
        <div className="d-flex flex-wrap">
        {receptionistTabMenu.map((item,i) => {
          return <NavItem key={i} className={view === item.title?'active':null}>
            <NavLink
             tag={Link}
             to={item.link}
             >
               <FontAwesomeIcon className="mie-2" icon={item.icon}/>
               {t(item.title)}
            </NavLink>
          </NavItem>
        })}
        {siteSettings && siteSettings.garageDoorPopup?
        <NavItem>
          <NavLink
           className="cursor-pointer"
           onClick={this.modalToggle}
           >
            <FontAwesomeIcon className="mie-2" icon='car'/>             
            {t('Garage Door')}
          </NavLink>
        </NavItem>
        :null}
        </div>
        {showAdmin?
        <NavItem className={view === 'admin'?'active':null}>
          <NavLink
           tag={Link}
           to={'/manager/dashboard'}
           >
             <FontAwesomeIcon className="mie-2" icon="toolbox"/>
             {t("Admin")}
             {isPrinterErrors?<FontAwesomeIcon icon="exclamation-triangle" className="mis-2 mie-0 heartBeat" />:null}
          </NavLink>
        </NavItem>
        :null}
      </Nav>
      <LanguageSelector />
      <Modal isOpen={this.state.modal} toggle={this.modalToggle} centered={true} modalClassName="garageOpenModal">
        <div className="modal-header">
          {t("Garage Door")}
          <button type="button" className="close" onClick={this.modalToggle} aria-label="Minimize"><span aria-hidden="true">&mdash;</span></button>
        </div>
        <ModalBody>
          <div className="text-center">
            <Button className="btn-secondary btn-lg mx-auto mt-3 mb-3" loading={isSubmitting} onClick={() => this.handleOpen()}>{t("garageOpenButton")}</Button>
          </div>
        </ModalBody>
      </Modal>
      </>
  )}
}

export default withTranslation()(ReceptionistTabs);
